import { FixedDateRanges } from "../shared/components/date-picker/date-picker.component";

export interface DateRangeValue {
  startDate: Date | null;
  endDate: Date | null;
  relativeDate?: FixedDateRanges;
}

export const getEstDate = function(date?: Date): string{
  date ??= new Date();
  // Subtract 1 hour to guarantee data is available for yesterday in est time
  date.setTime(date.getTime() - 60 * 60 * 1000);
  return filtersFormatter.format(date);
}

export const shortDateFormatter = new Intl.DateTimeFormat('en-US', {
  timeZone: 'America/Los_Angeles',
  year: 'numeric',
  month: 'short',
  day: 'numeric'
});

export function getManagementDateFormat(date: string) {
  return new Date(date).toDateString().slice(4).replace(/(\d{2})\s/, "$1, ");
}

export const subtractDays = function(date: Date, days: number): Date{
  return new Date(date.getTime() - days * 24 * 60 * 60 * 1000);
}

export const getRelativeDate = function(days: number): FixedDateRanges | undefined {
  switch (days) {
    case 1:
      return FixedDateRanges.YESTERDAY;
    case 7:
      return FixedDateRanges.LAST_7_DAYS;
    case 14:
      return FixedDateRanges.LAST_14_DAYS;
    case 30:
      return FixedDateRanges.LAST_30_DAYS;
    default:
      return undefined;
  }
}

export const getLastNumDays = function(days: number): DateRangeValue {
  const endDate = new Date();
  const startDate = new Date();
  startDate.setDate(startDate.getDate() - days);
  endDate.setDate(endDate.getDate() - 1);
  return { startDate, endDate, relativeDate: getRelativeDate(days) };
}

const filtersFormatter = new Intl.DateTimeFormat('en-CA', {
  year: 'numeric',
  month: '2-digit',
  day: '2-digit',
});

export const formatDateRangeForFilters = function(dateRange: DateRangeValue): Record<string, any> {
  return {
    startDate: filtersFormatter.format(new Date(dateRange.startDate as Date)),
    endDate: filtersFormatter.format(new Date(dateRange.endDate as Date))
  };
}

export const getThisMonth = function(): DateRangeValue {
  const now = new Date();
  const startDate = new Date(now.getFullYear(), now.getMonth(), 1);
  const endDate = new Date();
  endDate.setDate(endDate.getDate() - 1);

  return { startDate, endDate, relativeDate: FixedDateRanges.THIS_MONTH };
}

export const getLastMonth = function(): DateRangeValue {
  const now = new Date();
  const startDate = new Date(now.getFullYear(), now.getMonth() - 1, 1);
  const endDate = new Date(now.getFullYear(), now.getMonth(), 0);
  return { startDate, endDate, relativeDate: FixedDateRanges.LAST_MONTH };
}

export const formatFullDate = function(dateString: string | Date): string {
  const date = typeof dateString === 'string' ? new Date(dateString) : dateString;
  if (isNaN(date.getTime())) return '';
  return new Intl.DateTimeFormat('en-US', {
    month: 'long',
    day: 'numeric',
    year: 'numeric'
  }).format(date);
}
